import { Contact, ContactSummary } from '../contact';
import { AuditDetails, Entity, EntityLink } from '../entity';
import { TaxInclusiveOption } from '../purchase';
import { ItemSection } from '../quotes';
import { ActivityEntityName } from '../shared';

export enum SaleOrderStatus {
    New = "New",
    Invoiced = 'Invoiced',
    Cancelled = 'Cancelled'
}

export interface SaleOrder extends Entity, AuditDetails {
    saleOrderNumber?: string;
    date?: Date;
    expiryDate?: Date;

    account: Contact,
    contact?: ContactSummary;
    customerRef?: string;

    billingCompany?: Entity;

    status: SaleOrderStatus;
    sections?: ItemSection[];
    taxInclusiveOption?: TaxInclusiveOption;

    totalEx?: number;
    totalInc?: number;
    totalTax?: number;

    links?: EntityLink[];
    priceList: Entity;
    theme?: Entity;
}